import styles from "./index.module.scss";
import { IAuthors } from "../../types/INote";

export default function NoteAuthor({ authors }: { authors: IAuthors[] }): JSX.Element {
  return (
    <div className={styles.author} data-e="note-author">
      {authors.map((a: IAuthors, i: number) => {
        return (
          <span key={i}>
            {!i ? "" : ", "}
            {a.name}
          </span>
        );
      })}
    </div>
  );
}
